<template>
  <div class="users">

      <v-content class="pa-10">

          <v-row no-gutters>
            <div class="headline text-capitalize pb-5">Users </div>
            <v-spacer></v-spacer>
            <v-btn class="blue-grey" dark @click="addUseModal = true">Add New User</v-btn>
        </v-row>

        <v-data-table :headers="headers" :items="users" :items-per-page="10" :loading="isLoading" class="elevation-1">

            <template v-slot:item.username="{ item }">
                <span v-if="item.username == ''" class="grey--text">Unavailable</span>
                {{ item.username }}
            </template>

            <template v-slot:item.admin="{ item }">
                <v-btn text small v-if="item.admin" class="warning" @click="removeAdmin(item.email)">Remove Admin</v-btn>
                <v-btn text small v-if="!item.admin" class="info" @click="makeAdmin(item.email)">Make Admin</v-btn>
            </template>

            <template v-slot:item.status="{ item }">
                <span class="green--text" v-if="!item.status">Active</span>
                <span class="grey--text" v-if="item.status">Disabled</span>
            </template>

            <!-- password -->
            <template v-slot:item.password="{ item }">
                <span v-if="!item.lock">{{ item.password }}</span>
                <span v-if="item.lock">{{ item.password | hidePwd }}</span>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" class="pl-2" @click="toggleAccess(item.id)"><v-icon>mdi-eye</v-icon></v-btn>
                    </template>
                    <span>Show Password</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" class="pl-4" v-clipboard="item.password" @success="copied" :disabled="item.lock"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </template>
                    <span>Copy Password</span>
                </v-tooltip>
            </template>

            <!-- actions -->
            <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" @click="editModal(item.uid)"><v-icon>mdi-file-document-edit</v-icon></v-btn>
                    </template>
                    <span>Edit Record</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon x-small v-on="on" @click="deleteUser(item.uid)"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>
            </template>

        </v-data-table>

        <!-- modals -->

        <add-user v-if="addUseModal" @close="addUseModal = false"></add-user>

        <edit-user v-if="editUserModal" :userUID="userUID" @close="editUserModal = false"></edit-user>

        <!-- dialog -->

        <v-dialog v-model="accessDialog" width="500">
            <v-card>
                <v-card-text class="pt-5">
                    <v-text-field v-model="code" label="Please Enter Secret Code" required @keyup.enter="togglePassword(recordID, users)" autofocus></v-text-field>
                    <div v-if="accessWrong" class="red--text">Code is incorrect! Try again</div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn dark @click="closeDialog()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue-grey white--text" @click="togglePassword(recordID, users)">Verify</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

      </v-content>
      
  </div>
</template>

<script>
import { db, functions } from '@/plugins/appfirebase'
import addUser from '@/components/newUser'
import editUser from '@/components/editUser'

export default {

    components: { addUser, editUser },

    created() {

        this.getUsers();

        // request codes from server
        this.$store.dispatch('requestCodes');
    },

    data() {
        return {
            headers: [
                { text: 'N', value: 'id', width: '5%', active: true },
                { text: 'Username', value: 'username', width: '20%', active: true },
                { text: 'E-mail', value: 'email', width: '20%', active: true },
                { text: 'Password', value: 'password', width: '10%', align: 'right'},
                { text: 'Role', value: 'admin', width: '15%', active: true },
                { text: 'Status', value: 'status', width: '15%', active: true },
                { text: 'Date', value: 'date', width: '10%', active: true },
                { text: 'Action', value: 'action', width: '20%', align: 'right', active: true },
            ],
            users: [],
            sortedUsers: [],
            userUID: '',
            isLoading: false,
            addUseModal: false,
            editUserModal: false,
            code: '',
            accessDialog: false,
            accessWrong: false,
            recordID: '',
            snackbar: false
        }
    },

    methods: {

        getUsers() {

            this.isLoading = true;
            const allUsers = functions.httpsCallable('listAllUsers');

            allUsers().then(async results => {
                
                for (let i in results.data) {
                    const user = await db.collection('users').doc(results.data[i].uid).get().then(doc => { 
                        this.isLoading = false
                        return doc.data() ? doc.data() : {password: ''}
                    });
                    // console.log(userPassword)
                    this.users.unshift({
                        id: parseInt(i)+1,
                        uid: results.data[i].uid,
                        username: results.data[i].username ? results.data[i].username : '',
                        password: user.password,
                        lock: user.lock,
                        email: results.data[i].email,
                        admin: results.data[i].admin ? results.data[i].admin.admin : false,
                        status: results.data[i].status,
                        date: new Date(results.data[i].signup_date).toLocaleString()
                    })
                }
            }).catch(err => { console.log(err) })
        },

        makeAdmin(email) {
            this.isLoading = true
            const makeAdminRole = functions.httpsCallable('addAdminRole');

            makeAdminRole({ email }).then(result => {
                this.isLoading = false
                if (result.data.errorInfo) { console.log(result.data.errorInfo.message) } else { this.$router.go() }
            }).catch(err => { console.log(err) })
            
        },

        removeAdmin(email) {
            this.isLoading = true
            const removeAdminRole = functions.httpsCallable('removeAdminRole');

            removeAdminRole({ email }).then(result => {
                this.isLoading = false
                if (result.data.errorInfo) { console.log(result.data.errorInfo.message) } else { this.$router.go() }
            }).catch(err => { console.log(err) })
            
        },

        deleteUser(uid) {
            this.isLoading = true
            const deleteThisUser = functions.httpsCallable('deleteUser');

            deleteThisUser({ uid }).then( result => {

                db.collection('users').doc(uid).delete().then(() => {
                    this.isLoading = false;
                    if (result.data.errorInfo) { this.message = result.data.errorInfo.message; } else { this.$router.go() }
                })    

            }).catch( err => { console.log(err) });
        },

        editModal(uid) {
            this.editUserModal = true
            this.userUID = uid
        },

        toggleAccess(id) {
            
            const array = this.users;
            // Find index of a record by id
            let i = array.map( (key) => { return key.id; }).indexOf(id);

            if ( array[i].lock == true ) {      // if record is locked for hidden
                this.accessDialog = true                // then open dialog to verify code
                this.recordID = id
            }

            if ( array[i].lock == false ) {                 // if record is unlocked
                array[i].lock = !array[i].lock;     // then turn the record to lock for hidden
            }
            
        },

        togglePassword(id, array) {

            // get code from store data
            let codes = this.$store.state.codes;

            if (this.code == codes.pwd ) { 

                let i = array.map( (key) => { return key.id; }).indexOf(id);
                array[i].lock = !array[i].lock;
                this.accessDialog = !this.accessDialog

            } else {
                this.accessWrong = true
            }
            this.code = ''
        },
        copied() {
            this.snackbar = true;
        },
        closeDialog() {
            this.accessDialog = false
            this.accessWrong = false
        }

    },
    filters: {
        hidePwd(string) {
            return string.replace(/./g, "*");
        }
    }

}
</script>

<style>

</style>